var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Refresh_icon",
    "data-name": "Refresh icon",
    d: "M15047.683,12871.632a9,9,0,0,1,0-18,9.1,9.1,0,0,1,6.308,2.571l.527.516v-2.466a.621.621,0,0,1,1.242,0v4.506a.2.2,0,0,1,0,.067v.082a.623.623,0,0,1-.621.621h-4.656a.621.621,0,0,1,0-1.242h3.663l-.4-.5a7.762,7.762,0,1,0-6.061,12.615,7.442,7.442,0,0,0,.931-.059,7.764,7.764,0,0,0,6.834-7.711.62.62,0,0,1,1.239,0A9.012,9.012,0,0,1,15047.683,12871.632Z",
    transform: "translate(-15038.683 -12853.632)",
    fill: "#242424",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/Refresh-icon.31b115a76e725d748676315cbaccf41b.svg";
export { ForwardRef as ReactComponent };